import { ConfigType } from "./type";

export const prodConf: ConfigType = {
  API_HOST: "https://api.auth0-mock.gotoloop.dev",
  AUTH0_DOMAIN: "login.gotoloop.dev",
  AUTH0_CLIENT_ID: "o5bnXYCxpcvwupQ8rDMvMMFSKrShs4Bk",
};
